/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type ContactTracingContactDtoResidencyType =
  (typeof ContactTracingContactDtoResidencyType)[keyof typeof ContactTracingContactDtoResidencyType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactTracingContactDtoResidencyType = {
  PRIVATE: 'PRIVATE',
  WITH_INDEX_PATIENT: 'WITH_INDEX_PATIENT',
  OTHER: 'OTHER',
} as const;
